import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputEmail from 'components/blocks/ManagementNewForms/Inputs/FormInputEmail';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import get from 'lodash/get';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputYear from 'components/blocks/ManagementNewForms/Inputs/FormInputYear';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import useCreateDeclaracionCeseTRADE from 'services/record/DeclaracionCeseTRADE/useCreateDeclaracionCeseTRADE';
import useUpdateDeclaracionCeseTRADEByID from 'services/record/DeclaracionCeseTRADE/useUpdateDeclaracionCeseTRADE';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const DeclaracionCeseTRADE = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


  const formMethods = useForm();
  const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;

  const { createDeclaracionCeseTRADE, dataCreateDeclaracionCeseTRADE, errorCreateDeclaracionCeseTRADE, loadingCreateDeclaracionCeseTRADE, successCreateDeclaracionCeseTRADE } = useCreateDeclaracionCeseTRADE()
  const { dataUpdateDeclaracionCeseTRADEById, errorUpdateDeclaracionCeseTRADEById, loadingUpdateDeclaracionCeseTRADEById, successUpdateDeclaracionCeseTRADEById, updateDeclaracionCeseTRADEById } = useUpdateDeclaracionCeseTRADEByID()

  const [datosAPI, setDatosAPI] = useState(dataUser);
  const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);

  const watchProvinciaCliente = watch("ClientePrincipal.ClienteProvincia");
  const watchProvinciaDescCliente = watch("ClientePrincipal.ClienteProvinciaDescripcion");
  const watchCommCliente = watch("ClientePrincipal.ClienteLocalidad");
  const watchCommDescCliente = watch("ClientePrincipal.ClienteLocalidadDescripcion");



  const adaptApiResponseToDefaultValues = (data: any) => {
    console.log("Data a Adaptar: ", data)
    if (data) {

      reset({
        DatosPersonales: {
          SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
          SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
          SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
          SolicitanteIPF: data?.DatosPersonales?.IPF || "",
          SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
          SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",
          SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
          SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
          SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
          SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
          SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
          SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
          SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
          SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
        },

        ClientePrincipal: {
          ClienteNombreEmpresa: data?.ClientePrincipal?.ClienteNombreEmpresa || "",
          ClienteCCC: data?.ClientePrincipal?.ClienteCCC || "",
          ClienteCIF: data?.ClientePrincipal?.ClienteCIF || "",
          ClienteDomicilio: data?.ClientePrincipal?.ClienteDomicilio || "",

          ClienteoNumero: data?.ClientePrincipal?.ClienteNumero || "", //
          ClientePuerta: data?.ClientePrincipal?.ClientePuerta || "",
          ClientePiso: data?.ClientePrincipal?.ClientePiso || "",
          ClienteEscalera: data?.ClientePrincipal?.ClienteEscalera || "",

          ClienteProvincia: data?.ClientePrincipal?.ClienteProvincia || "",
          ClienteProvinciaDescripcion: data?.ClientePrincipal?.ClienteProvinciaDescripcion || "",
          ClienteLocalidad: data?.ClientePrincipal?.ClientePoblacion || "",
          ClienteLocalidadDescripcion: data?.ClientePrincipal?.ClientePoblacionDescripcion || "",
          ClienteCodigoPostal: data?.ClientePrincipal?.ClienteCodigoPostal || "",
          ClienteTelefono: data?.ClientePrincipal?.ClienteTelefono || "",
          ClienteCorreoElectronico: data?.ClientePrincipal?.ClienteEmail || "",

          ClienteFechaInicioContrato: data?.ClientePrincipal?.ClienteFechaInicioContrato || null,
          ClienteFechaFinContrato: data?.ClientePrincipal?.ClienteFechaFinContrato || null,
          SolicitanteNumeroSS: data?.NumeroSeguridadSocial || "",
        },

        MotivoCese: {
          MotivoCese: data?.MotivoCese?.toString() || null,
        },

        DatosIngreso: {
          Ejercicio: data?.DatosIngreso?.Ejercicio || null,
          IngresoActividad: data?.DatosIngreso?.IngresoActividad || "",
          IngresoClientePrincipal: data?.DatosIngreso?.IngresoClientePrincipal || "",
          CalculoIngreso: data?.DatosIngreso?.CalculoIngreso || "",
          TitularEstablecimiento: data?.DatosIngreso?.TitularEstablecimiento ?? null, //*
          DomicilioEstablecimiento: data?.DatosIngreso?.DomicilioEstablecimiento || "",
        },

      });
    }

  }

  useEffect(() => {
    adaptApiResponseToDefaultValues(dataUser);
  }, [dataUser]);

  useEffect(() => {
    setDatosAPI(dataUser);
  }, [dataUser]);

  useEffect(() => {
    const a = parseFloat(getValues('DatosIngreso.IngresoActividad'));
    const b = parseFloat(getValues('DatosIngreso.IngresoClientePrincipal'));

    // Evitar división por 0 o valores no numéricos
    if (!isFinite(a) || a === 0 || !isFinite(b)) {
      setValue('DatosIngreso.CalculoIngreso', null);
      return;
    }

    const calculo = (b * 100) / a;
    const redondeado = Number(calculo.toFixed(2)); // Máx. 2 decimales

    if (!isNaN(redondeado)) {
      setValue('DatosIngreso.CalculoIngreso', redondeado);
    } else {
      setValue('DatosIngreso.CalculoIngreso', null);
    }

  }, [
    watch('DatosIngreso.IngresoActividad'),
    watch('DatosIngreso.IngresoClientePrincipal')
  ]);


  const onSubmit = async (data: any) => {
    console.log(data);
    setLoader(true);

    let prestacionId = dataUser?.PrestacionId || null;

    const datosEnvio = {
      // IDENTIFICACIÓN
      Id: dataUser?.Id || null,
      ExternalId: dataUser?.ExternalId || 0,
      PersonaId: dataUser?.PersonaId || 0,
      UsuarioId: dataUser?.UsuarioId || null,
      ExpedienteId: dataUser?.ExpedienteId || null,
      PrestacionId: prestacionId,

      Acepto: data?.Acepto ?? false,

      // -------------------------
      // DATOS PERSONALES
      // -------------------------
      DatosPersonales: {
        Nombre: data?.DatosPersonales?.SolicitanteNombre || "",
        Apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
        Apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
        IPF: data?.DatosPersonales?.SolicitanteIPF || "",
        IPFTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,

        Telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
        Fijo: data?.DatosPersonales?.SolicitanteFijo || "",
        Domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
        CodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
        Provincia: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || "",
        CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || "",
        NumeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || "",
        ComunidadCodigo: data?.DatosPersonales?.SolicitanteComunidadCodigo || "",
        ComunidadCodigoDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || "",

      },
      
      // -------------------------
      // CLIENTE PRINCIPAL
      // -------------------------
      ClientePrincipal: {
        ClienteNombreEmpresa: data?.ClientePrincipal?.ClienteNombreEmpresa || "",
        ClienteCCC: data?.ClientePrincipal?.ClienteCCC || "",
        ClienteCIF: data?.ClientePrincipal?.ClienteCIF || "",
        ClienteDomicilio: data?.ClientePrincipal?.ClienteDomicilio || "",

        ClienteNumero: data?.ClientePrincipal?.ClienteoNumero || "",
        ClienteEscalera: data?.ClientePrincipal?.ClienteEscalera || "",
        ClientePiso: data?.ClientePrincipal?.ClientePiso || "",
        ClientePuerta: data?.ClientePrincipal?.ClientePuerta || "",
        ClientePoblacion: data?.ClientePrincipal?.ClienteLocalidad || "",
        ClientePoblacionDescripcion: data?.ClientePrincipal?.ClienteLocalidadDescripcion || "",
        ClienteProvincia: data?.ClientePrincipal?.ClienteProvincia || "",
        ClienteProvinciaDescripcion: data?.ClientePrincipal?.ClienteProvinciaDescripcion || "",
        ClienteCodigoPostal: data?.ClientePrincipal?.ClienteCodigoPostal || "",
        ClienteFijo: data?.ClientePrincipal?.ClienteFijo || "",
        ClienteTelefono: data?.ClientePrincipal?.ClienteTelefono || "",
        ClienteEmail: data?.ClientePrincipal?.ClienteCorreoElectronico || "",

        ClienteFechaInicioContrato: data?.ClientePrincipal?.ClienteFechaInicioContrato || null,
        ClienteFechaFinContrato: data?.ClientePrincipal?.ClienteFechaFinContrato || null
      },

      // -------------------------
      // MOTIVO CESE
      // -------------------------
      MotivoCese: data?.MotivoCese?.MotivoCese != null
        ? parseInt(data.MotivoCese.MotivoCese)
        : null,

      // -------------------------
      // DATOS INGRESO
      // -------------------------
      DatosIngreso: {
        Ejercicio: data?.DatosIngreso?.Ejercicio || null,
        IngresoActividad: parseFloat(data?.DatosIngreso?.IngresoActividad) || null,
        IngresoClientePrincipal: parseFloat(data?.DatosIngreso?.IngresoClientePrincipal) || null,
        CalculoIngreso: parseFloat(data?.DatosIngreso?.CalculoIngreso) || null,
        TitularEstablecimiento: data?.DatosIngreso?.TitularEstablecimiento ?? null,
        DomicilioEstablecimiento: data?.DatosIngreso?.DomicilioEstablecimiento || ""
      }
    };
    console.log(datosEnvio)
    if (info) {
      createDeclaracionCeseTRADE(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
      setBloquearEnvio(true);
    } else {
      updateDeclaracionCeseTRADEById(dataUser?.Id, dataUser?.Id, datosEnvio)
      setBloquearEnvio(true);
    }


    setTimeout(() => {
      setLoader(false); //tiempo cargar DOM
    }, 500);
  };





  return (
    <FormProvider {...formMethods}>
      <div className="container form--simple-styled" id="formDeltawithoutleave">

        {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
        <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

        <Loader activeLoader={loader || loadingCreateDeclaracionCeseTRADE || loadingUpdateDeclaracionCeseTRADEById} label="Cargando Formulario"></Loader>








        {/* ////////////// COMIENZO FORMULARIO ////////////// */}
        {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
        <FormInfoCreateUpdate
          isCreate={info}
          estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
          estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
          fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
        />
        <FieldsetContainer legend="" disabled={false}>
          <p className='mb-2 parra-bold'>
            En virtud de la prescripción recogida en el R.D.L. 8/2015, de 30 de octubre, por la que se establece un sistema específico de protección por cese 
de actividad de los trabajadores autónomos, en cuyo artículo 332 se determina la forma de acreditación de la situación legal de cese de la 
actividad en cada uno de los supuestos tasados que enumeran en el artículo 331 a 336 del mismo cuerpo legal, se certifica lo siguiente: 
          </p>
          <p className='mb-2 text-left parra-bold'>D./Dña
            <InputTextIntegration
              name="DatosPersonales.SolicitanteNombreCompleto"
              inputType={1}
              disabled={true}
              minWidth={300}
            />

            con número de afiliación a la Seguridad Social
            <InputTextIntegration
              name="DatosPersonales.SolicitanteNumeroSS"
              inputType={1}
              disabled={true}
            />
            con DNI/NIF/pasaporte/NIE número
            <InputTextIntegration
              name="DatosPersonales.SolicitanteIPF"
              inputType={1}
              disabled={true}
            />
            y domicilio en
            <InputTextIntegration
              name="DatosPersonales.SolicitanteDomicilio"
              inputType={1}
              disabled={true}
              minWidth={500}
            />
            declara bajo su responsabilidad que:
          </p>
          <p className='mb-4'>
            Mi actividad cumple las condiciones establecidas en el artículo 11 de la Ley 20/2007, de 11 de julio, por la que se aprueba el
            Estatuto del Trabajador Autónomo, y en el artículo 2 del Real Decreto 197/2009, de 23 de febrero, por el que se desarrolla el
            Estatuto del Trabajo Autónomo en materia de contrato del trabajador autónomo económicamente dependiente.
          </p>

        </FieldsetContainer>
        <div className='m-3'></div>

        <AccordionForm title={'Datos cliente principal'} expandedInit={false} nombreError='ClientePrincipal' >
          <div className="row mb-4">
            <div className="col-xl-12">


              <FieldsetContainer legend="" disabled={false}>

                <FormInputText
                  name='ClientePrincipal.ClienteNombreEmpresa'
                  id='ClientePrincipal.ClienteNombreEmpresa'
                  label='Nombre de la otra empresa'
                  md={6}
                  xl={6}
                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteCCC'
                  id='ClientePrincipal.ClienteCCC'
                  label='CCC'
                  req='CCC del Cliente Principal obligatorio'
                  md={6}
                  xl={6}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteCIF'
                  id='ClientePrincipal.ClienteCIF'
                  label='CIF'
                  req='CIF del Cliente Principal obligatorio'
                  md={6}
                  xl={6}
                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteDomicilio'
                  id='ClientePrincipal.ClienteDomicilio'
                  req='Domicilio del Cliente Principal obligatorio'
                  label='Domicilio'
                  md={6}
                  xl={6}

                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteoNumero'
                  id='ClientePrincipal.ClienteNumero'
                  label='Número'
                  md={3}
                  xl={3}
                  disabled={false}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                />
                <FormInputText
                  name='ClientePrincipal.ClientePuerta'
                  id='ClientePrincipal.ClientePuerta'
                  label='Puerta'
                  md={3}
                  xl={3}
                  disabled={false}
                  
                />
                <FormInputText
                  name='ClientePrincipal.ClientePiso'
                  id='ClientePrincipal.ClientePiso'
                  label='Piso'
                  md={3}
                  xl={3}
                 
                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteEscalera'
                  id='ClientePrincipal.ClienteEscalera'
                  label='Esc./Bloque'
                  md={3}
                  xl={3}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                  disabled={false}
                />



                <div className="col-xl-6 col-md-6">
                  <Province
                    errors={errors}
                    register={register}
                    idCode={'ClientePrincipal.ClienteProvincia'}
                    watchProvinceDescription={watchProvinciaDescCliente}
                    idDescription={'ClientePrincipal.ClienteProvinciaDescripcion'}
                    watchProvinceCode={watchProvinciaCliente}
                    required='Debe seleccionar la provincia del Cliente Principal'
                    setValue={setValue}
                    disabled={false}
                  />
                </div>
                <div className="col-xl-6 col-md-6">
                  <TestCommunity
                    errors={errors}
                    register={register}
                    setValue={setValue}
                    watchProvinceCode={watchProvinciaCliente}
                    watchCommunityCode={watchCommCliente}
                    watchCommunityDescription={watchCommDescCliente}
                    idCode={'ClientePrincipal.ClienteLocalidad'}
                    idDescription={'ClientePrincipal.ClienteLocalidadDescripcion'}
                    filterByProvince={true}
                    disabled={false}
                    required='Debe seleccionar la Localidad del Cliente Principal'
                  />
                </div>

                <FormInputText
                  name='ClientePrincipal.ClienteCodigoPostal'
                  id='ClientePrincipal.ClienteCodigoPostal'
                  label='Codigo Postal'
                  req='Codigo Postal del Cliente Principal obligatorio'
                  md={3}
                  xl={3}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                  disabled={false}
                />

                <FormInputText
                  name='ClientePrincipal.ClienteTelefono'
                  id='ClientePrincipal.ClienteTelefono'
                  label='Teléfono Movil'
                  md={3}
                  xl={3}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                  disabled={false}
                />
                <FormInputText
                  name='ClientePrincipal.ClienteFijo'
                  id='ClientePrincipal.ClienteFijo'
                  label='Teléfono Fijo'
                  md={3}
                  xl={3}
                  pattern={/^[0-9]+$/}
                  patternMessage='Solo se permiten numeros enteros'
                  disabled={false}
                />

                  <FormInputEmail
                  name='ClientePrincipal.ClienteCorreoElectronico'
                  id='ClientePrincipal.ClienteCorreoElectronico'
                  label='Correo Electrónico'
                  md={3}
                  xl={3}
                  req='Es necesario el correo electrónico de la empresa'
                  disabled={false}
                />

                <FormInputFecha
                  name={'ClientePrincipal.ClienteFechaInicioContrato'}
                  id={'ClientePrincipal.ClienteFechaInicioContrato'}
                  label={'Fecha Inicio Contrato'} placeholder={''} md={6} xl={6} col={12}
                  req='La fecha de inicio de contrato es obligatoria'
                  maxDate={new Date(Date.now())}
                  disableDate={false}
                />
                <FormInputFecha
                  name={'ClientePrincipal.ClienteFechaFinContrato'}
                  id={'ClientePrincipal.ClienteFechaFinContrato'}
                  label={'Fecha Fin Contrato'} placeholder={''} md={6} xl={6} col={12}
                  req='La fecha de fin de contrato es obligatoria'
                  maxDate={new Date(Date.now())}
                  disableDate={false}
                />



              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>


        <AccordionForm title={'Motivo del Cese'} expandedInit={false} nombreError='MotivoCese' >
          <div className="row mb-4">
            <div className="col-xl-12">
              <FieldsetContainer legend="Motivo del Cese" disabled={false}>

                <FormInputRadioGroup
                  title="Motivo del Cese"
                  name="MotivoCese.MotivoCese"
                  required='Debe seleccionar el Motivo del Cese'
                  labels={[
                    "Terminación de la duración contractual, obra o servicio.",
                    "Incumplimiento contractual grave del cliente.",
                    "Rescisión de la relación contractual del cliente por causa justificada.",
                    "Rescisión de la relación contractual del cliente por causa injustificada.",
                    "Por muerte, incapacidad o jubilación del cliente.",
                  ]}
                  col={12}
                />

              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>

        <AccordionForm title={'Datos de Ingresos'} expandedInit={false} nombreError='DatosIngreso' >
          <div className="row mb-4">
            <div className="col-xl-12">
              <FieldsetContainer legend="" disabled={false}>

                <FormInputYear
                  id={`DatosIngreso.Ejercicio`}
                  name={`DatosIngreso.Ejercicio`}
                  label="Ejercicio/Año"
                  placeholder=""
                  md={6}
                  xl={6}
                  col={12}
                  maxDate={new Date()}
                  req={'El año del ejercicio es obligatorio'}
                />

                <FormInputText
                  name='DatosIngreso.IngresoActividad'
                  id='DatosIngreso.IngresoActividad'
                  label='Ingresos totales por la actividad'
                  md={6}
                  xl={6}
                  req='Debe introducir los ingresos totales por la actividad'
                  disabled={false}
                  pattern={/^[0-9]+([.,][0-9]+)?$/}
                  patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                />

                <FormInputText
                  name='DatosIngreso.IngresoClientePrincipal'
                  id='DatosIngreso.IngresoClientePrincipal'
                  label='Ingresos de cliente principal'
                  md={6}
                  xl={6}
                  req='Debe introducir los ingresos del cliente principal'
                  disabled={false}
                  pattern={/^[0-9]+([.,][0-9]+)?$/}
                  patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                />
                <FormInputText
                  name='DatosIngreso.CalculoIngreso'
                  id='DatosIngreso.CalculoIngreso'
                  label='% Cliente principal/total ingresos'
                  md={6}
                  xl={6}
                  disabled={true}
                  pattern={/^[0-9]+([.,][0-9]+)?$/}
                  modal='Cálculo Ingresos de cliente principal x100 / Ingresos totales por la actividad'
                  patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                />
                <FormInputCheckboxTable
                  title={"¿Es titular de un establecimiento mercantil, industrial o de otra naturaleza?"}
                  col={12}
                  labels={[
                    "Marquese si procede",
                  ]}
                  names={[
                    "DatosIngreso.TitularEstablecimiento",
                  ]}
                />
                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosIngreso.TitularEstablecimiento') === true} fields={['DatosIngreso.DomicilioEstablecimiento']}>


                  <p>
                    Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público, situado en (indique
                    dirección completa):
                    <InputTextIntegration
                      name="DatosIngreso.DomicilioEstablecimiento"
                      inputType={1}
                      disabled={false}
                      minWidth={300}
                    />
                    el cual permanecerá cerrado durante todo el período en
                    el que perciba prestación económica por cese de actividad.
                  </p>

                </AccordionDisplay>


              </FieldsetContainer>
            </div>
          </div>
        </AccordionForm>












        {/* ////////////// FINAL FORMULARIO ////////////// */}


        {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
        <FormBotonSubmit
          disableSubmit={bloquearEnvio}
          onSubmit={handleSubmit(onSubmit)}
          successCreate={successCreateDeclaracionCeseTRADE}
          successUpdate={successUpdateDeclaracionCeseTRADEById}
          errorCreate={errorCreateDeclaracionCeseTRADE}
          errorUpdate={errorUpdateDeclaracionCeseTRADEById}
          datosAPI={datosAPI}
          info={info}
          BloqueoForm={[1]}
          label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes, informándosele que, en caso de resultar inciertos, la Mutua se reserva el derecho de reclamación de la prestación a que hubieran dado lugar.'
        />


        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
          que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
          fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
        </p>

        <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
          En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
          personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
          cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
          podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
          escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
          debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
        </p>



      </div>
    </FormProvider>
  )
}

export default DeclaracionCeseTRADE
